import { useMemo } from 'react';
import { useMe } from './data.js';

/**
 * Funktionen der Firma (aus /api/me): `hat('bewaesserungsplan')`. Solange nichts bekannt ist (ältere API, noch nicht
 * geladen), gilt alles als freigeschaltet – die API prüft ohnehin selbst.
 */
export function useFunktionen() {
  const liste = useMe().data?.mandant?.funktionen;
  return useMemo(() => {
    const frei = Array.isArray(liste) ? new Set(liste) : null;
    return (name) => !frei || frei.has(name);
  }, [liste]);
}
